import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ValidationService } from './../../validation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from './../../_services/index';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.css']
})
export class ForgotComponent implements OnInit {
  ErrorMassage: any;
  forgotForm: any;
  public errorFlag = false;
  loading = false;
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private forgotpasswordservice: AuthenticationService
  ) { }

  ngOnInit() {
    this.validateForgotForm();
  }

  validateForgotForm() {
    this.forgotForm = this.formBuilder.group({
      'email': ['', [Validators.required, ValidationService.emailValidator]]
    });
  }

  forgot() {
    this.loading = true;
    const email = this.forgotForm.value.email;
    this.forgotpasswordservice.forgotPassword(
      email
    ).subscribe(
      (dataResponse) => {
        const response = dataResponse;
        if (response.success === 1 && response.statusCode === 200) {
          this.ErrorMassage = response.message;
          this.errorFlag = false;
          this.loading = false;
          this.forgotForm.reset({
            'email': ''
          });
        }
      },
      error => {
        this.loading = false;
        this.ErrorMassage = error.message;
        this.errorFlag = true;
      }
      );
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/forgot/forgot.component.ts